// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    scheduleReportList: [],
    totalRows: 0,
    rowsPerPage: 5,
    page: 0,
    selectedScheduleReport: null,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'scheduleReport',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setScheduleReports(state, action) {
            state.scheduleReportList = action.payload;
        },
        setScheduleReportRowPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        setScheduleReportPage(state, action) {
            state.page = action.payload;
        },
        setTotalRowReports(state, action) {
            state.totalRows = action.payload;
        },
        setSelectedScheduleReport(state, action) {
            state.selectedScheduleReport = action.payload;
        },
        setScheduleReport(state, action) {
            const data = action.payload;
            const rowIndex = state.scheduleReportList.findIndex((item) => item.id === data.id);
            if (rowIndex) {
                state.scheduleReportList[rowIndex] = data;
            }
        }
    }
});

// Reducer
export default slice.reducer;
export const { setSelectedScheduleReport, setScheduleReportRowPerPage, setScheduleReportPage } = slice.actions;
// ----------------------------------------------------------------------

export function getScheduleReports(data) {
    return async () => {
        try {
            const response = await axios.post('/reports/schedule-report', data);
            if (response.data.status) {
                dispatch(slice.actions.setScheduleReports(response.data.data));
                dispatch(slice.actions.setTotalRowReports(response.data.total_rows));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
